import { RESERVATION_PAGE_TYPE } from '../base/reservation/constants';
import { VOD_PAGE_TYPE } from '../base/vod/constant';
export const DEFAULT_ROOM_PROPERTY = RESERVATION_PAGE_TYPE.HELD_ROOM;
//RESERVATION_PAGE_TYPE.HELD_ROOM;
export const ROOM_PROPERTY_TYPES = [
    RESERVATION_PAGE_TYPE.HELD_ROOM,
    RESERVATION_PAGE_TYPE.RESERVE_ROOM,
    VOD_PAGE_TYPE.VOD_LIST
];
